import { CommonLanguageResponse } from '@/api/services/common/language/common-language.dto'
import { StrictNullable } from '@/shared/types/app.types'
import { CommonFilterModel } from '@/api/resources/common/shared/models/common.models'
import { EntityIdentifiersRequest } from '@/shared/models/http/http.model'
import { AgGridExportType } from '@/shared/models/ag-grid.model'
import { CommonSampleTypeResponse } from '@/api/services/common/sample-type/common-sample-type.dto'
import { CommonTopographicCodeResponse } from '@/api/services/common/topographic-code/common-topographic-code.dto'

export interface EnumTranslatedResponse<T> {
    enumValue: T
    translatedKey: string
}

export interface CommonContactInformationResponse {
    id: number
    email: string
    mainPhone: string
    emailNotificationEnabled: boolean
    smsNotificationEnabled: boolean
    otherPhone1: StrictNullable<string>
    otherPhone2: StrictNullable<string>
}

export interface CommonHealthManagementAreaResponse {
    active: boolean
    code: string
    id: number
    name: string
}

export interface CommonLaboratoryResponse {
    labId: number
    labName: string
    labExternalId: string
    labActive: boolean
}

export interface NamedPerson {
    name: string
    middleName: StrictNullable<string>
    surname1: string
    surname2: StrictNullable<string>
    fullName: string
}

export interface CommonPetitionerResponse extends NamedPerson {
    id: number
    code: string
    active: boolean
}

export interface CommonProtocolResponse {
    prtId: number
    prtName: string
    prtActive: boolean
}

export interface CommonUserappResponse {
    id: number
    fullName: string
    fullNameWithUsername: string
    middleName: string
    name: string
    surname1: string
    surname2: string
    username: string
}

///

export interface CommonCountryResponse {
    id: number
    name: string
    code: string
    active: boolean
}
export interface CommonProvinceResponse {
    id: number
    name: string
    country: CommonCountryResponse
    active: boolean
    code: string
}
export interface CommonMunicipalityResponse {
    id: number
    name: string
    province: CommonProvinceResponse
    active: boolean
    code: string
}
export interface CommonAddressResponse {
    id: number
    address: string
    postalCode: string
    notes:string
    country: CommonCountryResponse
    province: CommonProvinceResponse
    municipality: CommonMunicipalityResponse
}

export interface CommonGenderResponse {
    active: boolean // True if it is active; False otherwise
    code: string // Translated code of the gender
    id: number // Gender Id
    name: string // Name of the gender
    notTranslatedCode: string // Not translated code of the gender
}

export interface CommonBlobResponse{
    id: number
    text: string
    originalConcurrencyUpdatedAt: string
}

///

export interface EnumResponse {
    code: string
    translatedName: string
}

export interface TranslationResponse {
    id: number
    key: string
    value: string
    language: CommonLanguageResponse
    notes: string // TODO: nullable/optional
}

export interface TranslationRequest {
    languageId: number
    value: string
    notes?: string
}

export enum GridColumnRequestModifier {
    ONLY_ODD_ROWS = 'ONLY_ODD_ROWS',
    ONLY_EVEN_ROWS = 'ONLY_EVEN_ROWS',
    SHOW_BIDI_CODE = 'SHOW_BIDI_CODE'
}

// Object that represents a grid column to be exported/printed
export interface GridColumnRequest {
    headerName: string // Column headername
    field: string // Column field
    type: AgGridExportType // Column type class
    modifiers?: GridColumnRequestModifier[] // Column export modifiers
}

// Object that represents the grid data to be exported as a report
export interface ReportGridRequest {
    columns: GridColumnRequest[]
    sectionLabel: string // Label that represents filter sidebar selected to show in report
    entityIdentifiersRequest?: EntityIdentifiersRequest
    filterModel?: CommonFilterModel
}

export interface ManualShipmentRuleResponse {
    active: boolean,
    caseOwnerLaboratory: CommonLaboratoryResponse,
    destinationEntityInternalStatus: EnumResponse,
    destinationLaboratory: CommonLaboratoryResponse,
    entityType: EnumResponse,
    id: number,
    originEntityInternalStatus: EnumResponse,
    originLaboratory: CommonLaboratoryResponse,
    sampleType: CommonSampleTypeResponse,
    topographicCode: CommonTopographicCodeResponse
}

export interface PetitionerIndexResponse {
    id: number
    name: string
    middleName: string
    surname1: string
    surname2: string
    fullName: string
}
